// Shared descriptors also fit MAIN-879 #189's field-level problem renderer.
export function getWebsiteImportProblems(proposal) {
  if (!proposal?.websiteImport || proposal.publishedMenuId) return [];
  const problems = [];
  const add = (message) => problems.push({ field: null, message, fixable: false });
  // The API sets USD only for a clearly US-based page; there is no
  // conversion, so anything else has to be added by hand.
  if (proposal.currency !== "USD")
    add(
      proposal.currency
        ? `Prices are in ${proposal.currency}, not US dollars; add this item manually`
        : "Currency couldn't be confirmed as US dollars; check the source and add this item manually",
    );
  if (
    proposal.unsupportedCustomization ||
    proposal.addOnTypes?.length ||
    proposal.missingFields?.includes("customization")
  )
    add("Customization requires manual setup before publishing");
  if (proposal.classification === "Update" && proposal.matchedMenuId) {
    const price = proposal.editedFields?.price ?? proposal.price;
    const quantity = proposal.editedFields?.minQuantity ?? proposal.minQuantity;
    if (price == null || !Number.isFinite(Number(price)) || Number(price) <= 0)
      problems.push({ field: "price", message: "Price is required", fixable: true });
    if (!Number.isSafeInteger(Number(quantity)) || Number(quantity) <= 0)
      problems.push({
        field: "minQuantity",
        message: "Minimum quantity is required",
        fixable: true,
      });
  }
  return problems;
}
